enum ChatEvents {
  DENIED = 'denied',
  CONNECTED = 'connected',
  TYPING_ENDED = 'typingEnded',
  DISCONNECTED = 'disconnected',
  MESSAGE_ADDED = 'messageAdded',
  TYPING_STARTED = 'typingStarted',
  TOKEN_EXPIRE = 'tokenAboutToExpire',
  CONVERSATION_LEFT = 'conversationLeft',
  CONVERSATION_JOINED = 'conversationJoined',
  CONNECTION_STATE_CHANGE = 'connectionStateChanged',
}

export { ChatEvents };
